module.exports = __webpack_public_path__ + "img/preview-icon.9c71c331.svg";